// extracted by mini-css-extract-plugin
export default {"ExpandableArea":"_ExpandableArea--CEG8b","Hidden":"_Hidden--yBJid","Row":"_Row--Chpn8","CompanyArea":"_CompanyArea--eFsbb","SectionHeader":"_SectionHeader--R_u1l"};